import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import styles from "./index.module.scss";

import { LearnMore } from "../learn-more";
import clsx from "clsx";

export interface ProjectItemProps {
  index?: number;
  title: string;
  description: string;
  image: string;
  link?: string;
  imagePosition?: "left" | "right";
}

export function ProjectItem(props: ProjectItemProps) {
  const { ref, inView } = useInView({});
  const {
    title,
    description,
    image,
    link,
    imagePosition = "left",
    index
  } = props;
  const [isLeft, setIsLeft] = React.useState(true);

  useEffect(() => {
    setIsLeft(
      window.document.documentElement.clientWidth <= 768
        ? true
        : imagePosition === "left"
    );
  }, [imagePosition]);

  const imageElement = (
    <img
      src={image}
      alt={title}
      className={styles.img + " rounded object-fit-cover"}
    />
  );

  const textElement = (
    <>
      <h3 className={"waysglob-title " + styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      {link ? <LearnMore link={link} /> : null}
    </>
  );

  const content = (
    <>
      <div className="col-md-6">
        <div className={styles["left-wrapper"]}>
          {isLeft ? imageElement : textElement}
        </div>
      </div>
      <div className="col-md-6">
        <div className={styles["right-wrapper"]}>
          {isLeft ? textElement : imageElement}
        </div>
      </div>
    </>
  );

  return (
    <div
      ref={ref}
      className={clsx([
        "row",
        styles.row,
        "animate__animated",
        index % 2 === 0
          ? { animate__slideInRight: inView }
          : { animate__slideInLeft: inView }
      ])}
    >
      {content}
    </div>
  );
}
